import { render, staticRenderFns } from "./MigrationBlock.vue?vue&type=template&id=e247e2d8&scoped=true"
import script from "./MigrationBlock.vue?vue&type=script&lang=ts"
export * from "./MigrationBlock.vue?vue&type=script&lang=ts"
import style0 from "./MigrationBlock.vue?vue&type=style&index=0&id=e247e2d8&prod&lang=scss&scoped=true"
import style1 from "./MigrationBlock.vue?vue&type=style&index=1&id=e247e2d8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e247e2d8",
  null
  
)

export default component.exports